import { render, staticRenderFns } from "./SecondaryVoicemailSection.vue?vue&type=template&id=38934b85&"
import script from "./SecondaryVoicemailSection.vue?vue&type=script&lang=js&"
export * from "./SecondaryVoicemailSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports